import {
  useDismissStudentWhatsAppReminder,
  useGetStudentWhatsAppGroup,
  useSetStudentWhatsAppGroupJoined,
} from '@actions';
import WhatsAppGroupsModal from './WhatsAppGroupsModal';

const StudentWhatsAppGroupModal = () => {
  const { data, isLoading } = useGetStudentWhatsAppGroup();
  const { mutate: setJoined, isLoading: isSaving } = useSetStudentWhatsAppGroupJoined();
  const { mutate: dismiss } = useDismissStudentWhatsAppReminder();

  return (
    <WhatsAppGroupsModal
      title="Join your WhatsApp group"
      description="This is the group where you, your parent and your mentor keep in touch. Open it and tick it off once you are in; we will remind you next week otherwise."
      groups={data?.students ?? []}
      dismissedAt={data?.dismissedAt}
      isLoading={isLoading || !data}
      isSaving={isSaving}
      showGroupNames={false}
      onToggleJoined={(_studentId, joined) => setJoined({ joined })}
      onDismiss={() => dismiss({})}
    />
  );
};

export default StudentWhatsAppGroupModal;
